import React, { useEffect, useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { Lock, Mail, AlertCircle, Building2 } from 'lucide-react';
import { useEstablishmentAuth } from '../../context/EstablishmentAuthContext';
import './establishment.css';

function LoginPage() {
  const { status, signIn, signOut: doSignOut } = useEstablishmentAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (status === 'authorized') nav('/etablissement/gestion', { replace: true });
  }, [status, nav]);

  useEffect(() => {
    if (status === 'denied') {
      setError(
        "Ce compte ne dispose pas d'un accès au panneau établissement. Contacte l'équipe CrousRadar."
      );
      // Force sign-out so the UI doesn't loop
      doSignOut().catch(() => {});
    }
  }, [status, doSignOut]);

  if (status === 'authorized') return <Navigate to="/etablissement/gestion" replace />;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      await signIn(email.trim(), password);
    } catch (err) {
      const code = err && err.code;
      if (code === 'auth/invalid-credential' || code === 'auth/wrong-password' || code === 'auth/user-not-found') {
        setError('Identifiants incorrects.');
      } else if (code === 'auth/too-many-requests') {
        setError('Trop de tentatives, réessaie plus tard.');
      } else {
        setError("Impossible de se connecter pour le moment.");
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="est-login-page">
      <div className="est-login-card">
        <div className="est-login-head">
          <div className="est-login-icon">
            <Building2 size={28} />
          </div>
          <h1>Espace Établissement</h1>
          <p>Connexion réservée aux gestionnaires de RU CROUS.</p>
        </div>

        <form onSubmit={handleSubmit} className="est-login-form">
          <label className="est-field">
            <span>Email</span>
            <div className="est-input-wrap">
              <Mail size={16} />
              <input
                type="email"
                autoComplete="username"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
          </label>

          <label className="est-field">
            <span>Mot de passe</span>
            <div className="est-input-wrap">
              <Lock size={16} />
              <input
                type="password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                minLength={6}
              />
            </div>
          </label>

          {error && (
            <div className="est-alert est-alert-error">
              <AlertCircle size={16} />
              <span>{error}</span>
            </div>
          )}

          <button
            type="submit"
            className="est-btn est-btn-primary"
            disabled={submitting}
          >
            {submitting ? 'Connexion…' : 'Se connecter'}
          </button>

          <p className="est-login-footnote">
            Pas encore de compte ? Les comptes sont créés manuellement par l'équipe
            CrousRadar. Contacte <a href="mailto:contact@crousradar.fr">contact@crousradar.fr</a>.
          </p>
        </form>
      </div>
    </div>
  );
}

export default LoginPage;
